// extracted by mini-css-extract-plugin
module.exports = {"container":"globalConfirmationModal_container__2PCgz","modal":"globalConfirmationModal_modal__UB2rA","btnContainer":"globalConfirmationModal_btnContainer__23Evo"};